import { render } from "./MbrandUpdate.vue?vue&type=template&id=475f0fe2&scoped=true"
import script from "./MbrandUpdate.vue?vue&type=script&lang=js"
export * from "./MbrandUpdate.vue?vue&type=script&lang=js"

import "./MbrandUpdate.vue?vue&type=style&index=0&id=475f0fe2&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475f0fe2"]])

export default __exports__